import Immutable from 'seamless-immutable'
import Api from '../lib/api'

export const SET_USER = 'SET_USER'
export const SET_WORKSPACES = 'SET_WORKSPACES'
export const SET_WORKSPACE = 'SET_WORKSPACE'

export const ROLES = {
    ADMIN: 'admin',
    WORKSPACEADMIN: 'workspaceadmin',
    ORGANIZATIONADMIN: 'organizationadmin',
    CLIENT: 'client'
}
export const ROLE_LABELS = {
    'admin' : 'Admin',
    'workspaceadmin': 'Workspace Admin',
    'organizationadmin': 'Firmenadmin',
    'client': 'Benutzer'
}

export const userHasRole = (user, roles)=>{
    return user && roles.indexOf(user.role) > -1
}

export const loadWorkspaces = ({email})=>{
    return async (dispatch) =>{
        console.log('load workspaces', email)
        const workspaces = await Api.getWorkspaces({email})
        dispatch({
            type:SET_WORKSPACES,
            workspaces
        })
    }
}

export const loadWorkspace = ({workspaceSlug})=>{
    return async (dispatch) =>{
        const workspace = await Api.getWorkspace({workspaceSlug})
        dispatch({
            type: SET_WORKSPACE,
            workspace
        })
    }
}

export function login({email, password, workspaceId, workspaceSlug}) {
    return async (dispatch) => {
        let user 
        try{
            user = await Api.login({email,password, workspaceId, workspaceSlug})
            dispatch({
                type: SET_USER,
                user
            })
        }catch(e){

        }
        
        return user
    }
}

export function logout() {
    return async (dispatch) => {

        Api.logout()

        dispatch({
            type: SET_USER,
            user: null
        })
        
        return null
    }
}

export function getIntialState(state){

    let user = Api.getAuthUser()
    let workspace = Api.getAuthWorkspace()

    return Immutable({user, workspace})
}

const initialState = Immutable({user: null})

export const reducer = (state = initialState, action)=>{

    switch (action.type) {
    case SET_WORKSPACES:
        return state.set('workspaces', action.workspaces)
    case SET_WORKSPACE:
        return state.set('workspace', action.workspace)
    case SET_USER:
        return state.set('user', action.user)
    default:
        return state
    }

}



// WEBPACK FOOTER //
// ./src/actions/auth.js